import { Input } from '@/components/ui/input'
import getSymbolFromCurrency from 'currency-symbol-map'

const SelectionList = ({ audiences, color, stageId, store, currency }) => {
    const { getAudienceManualAmount, setAudienceManualAmount, validateAudienceManualAmount } = store

    const handleAmountChange = (audienceId, value) => {
        const numericValue = parseFloat(value) || 0
        setAudienceManualAmount(stageId, audienceId, numericValue)
    }

    const handleAmountBlur = (audienceId) => {
        validateAudienceManualAmount(stageId, audienceId)
    }

    return (
        <div className="tw:flex tw:flex-col tw:border-t tw:border-b tw:divide-y">
            {audiences.map((audience) => (
                <div
                    key={audience.id}
                    style={{ borderLeftColor: color }}
                    className="tw:border-l-4 tw:hover:bg-gray-500 tw:flex tw:justify-between tw:group tw:px-5 "
                >
                    <div className="tw:py-4 tw:flex tw:gap-1.5 tw:items-center tw:justify-center">
                        <span className="tw:text-sm tw:ml-1">{audience.name}</span>
                    </div>
                    <div className="tw:flex tw:items-center tw:justify-center">
                        <div className="tw:relative">
                            <span className="tw:absolute tw:left-3 tw:top-1/2 tw:transform tw:-translate-y-1/2 tw:text-sm tw:pointer-events-none">
                                {getSymbolFromCurrency(currency)}
                            </span>
                            <Input
                                min="0"
                                step="1"
                                type="number"
                                className="tw:h-8 tw:w-32 tw:pl-8"
                                value={getAudienceManualAmount(stageId, audience.id) || ''}
                                onChange={(e) => handleAmountChange(audience.id, e.target.value)}
                                onBlur={() => handleAmountBlur(audience.id)}
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default SelectionList
